
import { defineComponent } from "vue";
import PageButtonsComponent from "@/components/PageButtons.component.vue";
import ParameterForm from "@/components/parameter/parameterForm.component.vue";
import ParameterListComponent from "@/components/parameter/parameterList.component.vue";
import { errorHandlerDefault } from "@/utils/handler.util";
import { ElMessage } from "element-plus";
import { getAvailableRoutes } from "@/service/user.service";
import { RootState } from "@/types/state.type";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
export default defineComponent({
  components: {
    PageButtonsComponent,
    ParameterForm,
    ParameterListComponent,
  },
  data() {
    return {
      showParameterForm: false,
    };
  },
  async mounted() {
    const store = useStore<RootState>();
    const route = useRoute();
    const router = useRouter();

    if (store.state.auth.user?.id) {
      try {
        let userRoutes = await getAvailableRoutes(store.state.auth.user.id);
        if (userRoutes.length > 0 && !userRoutes.includes(route.path)) {
          router.go(-1);
        }
      } catch (error) {
        console.error("Error fetching routes:", error);
      }
    }
  },
  methods: {
    openParameterFormDialog() {
      this.showParameterForm = true;
    },
    closeParameterFormDialog() {
      this.showParameterForm = false;
    },
    async saveParameter() {
      await (this.$refs["paramForm"] as InstanceType<typeof ParameterForm>)
        .doSave()
        .then(() => {
          (
            this.$refs["parameterList"] as InstanceType<typeof ParameterListComponent>
          ).refreshParameter();
          this.closeParameterFormDialog();
          ElMessage.success(this.$t("success.action"));
        })
        .catch(errorHandlerDefault);
    },
  },
});
